// Founder Admin — control de acceso al rol de Founder.
//
// Paso 1.2 (oct-2026): la identidad del founder se decide SOLO por lo que
// entrega el backend: el flag `is_root_founder` (role super_admin en DB) o el
// rol `super_admin`/`founder_admin`. AuthContext normaliza super_admin→admin en
// `role`, por eso el flag es la señal fiable. Ningún correo vive en el bundle.

// Roles administrativos (efectivos) para la vista fiel.
const ADMIN_VIEW_ROLES = new Set(['admin', 'super_admin', 'founder_admin']);
const FOUNDER_ROLES = new Set(['super_admin', 'founder_admin']);
const hasFounderIdentity = (user) => user.is_root_founder === true || FOUNDER_ROLES.has(user.real_role || user.role);

// ¿Este usuario es el founder verdadero?
// VISTA FIEL (mandato Founder, jun-2026): cuando el founder opera con un rol
// de vista NO administrativo (real_role presente + rol activo p.ej. 'barber'),
// devuelve false para que TODA superficie founder/admin quede oculta.
export const isFounderUser = (user) => {
  if (!user) return false;
  if (user.real_role && !ADMIN_VIEW_ROLES.has(user.role)) return false;
  return hasFounderIdentity(user);
};

// ¿Mostrar el rol "Founder Admin" en el selector de roles?
// Solo cuando la IDENTIDAD real (real_role || role) es de founder.
export const canShowFounderRole = (user) => {
  if (!user) return false;
  return hasFounderIdentity(user);
};

/**
 * ¿Este usuario puede usar role-switching (modo dev/QA)?
 * SINGLE SOURCE OF TRUTH para mostrar/ocultar "Cambiar rol" en la UI.
 * La IDENTIDAD real (real_role) decide, no el rol de vista.
 */
export const canSwitchRoles = (user) => {
  if (!user) return false;
  return hasFounderIdentity(user);
};

/**
 * Selector de vistas — Opción A (mandato founder, sep-2026):
 * toda cuenta con rol administrativo puede alternar vistas. NO otorga
 * poderes de founder (CFO console, Launch Control, tabs founderOnly, Zelle).
 */
export const canUseViewSelector = (user) => {
  if (!user) return false;
  const identityRole = user.real_role || user.role;
  if (identityRole === 'admin') return true;
  return canSwitchRoles(user);
};
